import moment from "moment";
import { Letter } from "../models/custom/enums/letter";
import { MeDto } from "../models/dtos/me.dto";
import { UserState } from "../models/enums/userState";
import { Constants } from "./constants";

export class Helpers {
  public static wait = (ms: number = 1000) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  public static isEnvProd(): boolean {
    const env: string = `${process.env.REACT_APP_ENV}`;
    return env === "production";
  }

  public static getQueryParam(search: string, query: string): string | null {
    const searchParams: URLSearchParams = new URLSearchParams(search);
    return searchParams.get(query);
  }

  public static isUserJustCreated(me?: MeDto): boolean {
    return !!me && me.state === UserState.JUST_CREATED;
  }

  public static isFirstComeModal(me?: MeDto, rank?: number): boolean {
    return this.isUserJustCreated(me) || rank === -1;
  }

  public static getDiffSeconds(date: Date): number {
    return moment(date).utc().diff(moment().utc(), "seconds");

    // Backend response format GMT-0: 2023-03-23T11:30:00 (should be: 2023-03-23T11:30:00.000Z) for Istanbul time is 2023-03-23T14:30:00
    // const now = moment().subtract(moment().utcOffset(), "minute");
    // return moment(date).diff(now, "second");
  }

  public static getDiffMilliseconds(date: Date): number {
    return moment(date).utc().diff(moment().utc(), "milliseconds");

    // Backend response format GMT-0: 2023-03-23T11:30:00 (should be: 2023-03-23T11:30:00.000Z) for Istanbul time is 2023-03-23T14:30:00
    // const now = moment().subtract(moment().utcOffset(), "minute");
    // return moment(date).diff(now, "milliseconds");
  }

  public static getQuestionCountdownSeconds(questionExpireAt?: Date): number {
    if (!questionExpireAt) return 0;
    const questionSecondsLeft = Helpers.getDiffSeconds(questionExpireAt);
    return questionSecondsLeft - Constants.questionDurationInSeconds;
  }

  public static getLetterFromIndex(index: number): string {
    switch (index) {
      case 0:
        return Letter.A;
      case 1:
        return Letter.B;
      case 2:
        return Letter.C;
      case 3:
        return Letter.D;
      case 4:
        return Letter.E;
      case 5:
        return Letter.F;
      case 6:
        return Letter.G;
      default:
        return "";
    }
  }

  public static debounce(fn: Function, delay: number) {
    let timerId: any;
    return function (...args: any[]) {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        fn(...args);
        timerId = null;
      }, delay);
    };
  }
}
